import React, { useState } from "react";
import { sourceSellerAddressFields, destinationBuyerAddressFields } from "../formFields/shippmentTabsFields";
import GenericFormTab from "./GenericFormTab"; // adjust path

export default function AddressesTab({ formData, onChange, errors = {}, viewOnly = false , isEdit = true }) {
    const [activeTab, setActiveTab] = useState("supplier");

    return (
        <div>
            <ul className="nav nav-pills mb-3 gap-2 p-2 rounded shadow-sm">
                <li className="nav-item">
                    <button
                        className={`nav-link d-flex align-items-center px-2 py-1 fw-semibold ${activeTab === "supplier" ? "active btn-primary text-white" : "text-dark"}`}
                        onClick={() => setActiveTab("supplier")}
                    >
                        <i className="bi bi-box-seam me-2"></i> Source / Supplier
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link d-flex align-items-center px-2 py-1 fw-semibold ${activeTab === "buyer" ? "active btn-primary text-white" : "text-dark"}`}
                        onClick={() => setActiveTab("buyer")}
                    >
                        <i className="bi bi-person-lines-fill me-2"></i> Destination / Buyer
                    </button>
                </li>
            </ul>

            <div className="tab-content rounded p-3">
                {activeTab === "supplier" && (
                    <GenericFormTab fields={sourceSellerAddressFields} formData={formData} onChange={onChange} errors={errors} readOnly={viewOnly} isEdit={isEdit} />
                )}
                {activeTab === "buyer" && (
                    <GenericFormTab fields={destinationBuyerAddressFields} formData={formData} onChange={onChange} errors={errors} readOnly={viewOnly} isEdit={isEdit} />
                )}
            </div>
        </div>
    );
}
